import styled from 'styled-components/macro'

const SearchFooter = styled.div`
  display: flex;
  justify-content: center;
`
export default SearchFooter
